<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                grid: false
            }
        },
        mounted() {
        }
    }
</script>
